import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { CheckboxCustomEvent } from '@ionic/angular';

@Component({
  selector: 'sanitization-confirm-modal',
  templateUrl: './sanitization-confirm-modal.component.html',
  styleUrls: ['./sanitization-confirm-modal.component.scss']
})
export class SanitizationConfirmModalComponent implements OnInit {
  
  @Input() reset!: EventEmitter<boolean>;
  @Output() confirmed: EventEmitter<void> = new EventEmitter();

  public haveConfirmAboutCleaning: boolean = false;
  public haveConfirmAboutPets: boolean = false;

  public ngOnInit(): void {
    if (this.reset) {
      this.reset.subscribe(() => {
        this.haveConfirmAboutCleaning = false;
        this.haveConfirmAboutPets = false;
      })
    }
  }

  public confirmAboutCleaning(e: CheckboxCustomEvent) {
    this.haveConfirmAboutCleaning = e.detail.checked;
  }

  public confirmAboutPets(e: CheckboxCustomEvent) {
    this.haveConfirmAboutPets = e.detail.checked;
  }
}
